var map = {
	"./Instagram.svg": 5872,
	"./Linkedin.svg": 7362,
	"./Twitter.svg": 6935,
	"./circle.svg": 6989,
	"./facebook.svg": 6032,
	"./icon.svg": 7815,
	"./mail.svg": 8860,
	"./password.svg": 4711,
	"./youtube.svg": 2790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4192;